
/**
 * Current user reducer.
 */

export default function currentUser (state = {}, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/current-user.js